import { ActionsUnion, createAction } from "store/helper";

import { IClearNavigationItemBadgePayload, ISetNavigationItemBadgePayload } from "./interfaces";

export enum NavigationViewActionsNames {
  SET_ITEM_BADGE = "VIEW/MAIN_NAVIGATION/SET_ITEM_BADGE",
  CLEAR_ITEM_BADGE = "VIEW/MAIN_NAVIGATION/CLEAR_ITEM_BADGE",
}

export const NavigationViewActions = {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  setNavigationItemBadge: (payload: ISetNavigationItemBadgePayload) =>
    createAction(NavigationViewActionsNames.SET_ITEM_BADGE, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  clearNavigationItemBadge: (payload: IClearNavigationItemBadgePayload) =>
    createAction(NavigationViewActionsNames.CLEAR_ITEM_BADGE, payload),
};

export type NavigationViewAction = ActionsUnion<typeof NavigationViewActions>;
